import { ProjectAnalysisTabs, ProjectAnalysisTabType } from "@/types/projectAnalysisTab";
import { FeatureManagementType } from "@api/apiClient";
import useAppStore from "@hooks/useAppStore";
import { useMemo } from "react";


const useProjectAnalysisTabs = () => {
  const appStore = useAppStore();

  // Create a lookup table since the tab index can change based on feature flags
  const projectAnalysisTabs = useMemo(() => {
    const projectAnalysisTabs: number[] = [];
    projectAnalysisTabs.push(ProjectAnalysisTabs.Models);
    projectAnalysisTabs.push(ProjectAnalysisTabs.Scenarios);
    projectAnalysisTabs.push(ProjectAnalysisTabs.Assign);
    projectAnalysisTabs.push(ProjectAnalysisTabs.Results);
    if (appStore.hasFeature(FeatureManagementType.AdHocElements)) projectAnalysisTabs.push(ProjectAnalysisTabs.Additions);
    return projectAnalysisTabs;
  }, [appStore.settings]);

  const getProjectAnalysisTabIndex = (tab: ProjectAnalysisTabType) => {
    const tabId = ProjectAnalysisTabs[tab];
    return projectAnalysisTabs.indexOf(tabId);
  };

  return { tabs: projectAnalysisTabs, getTabIndex: getProjectAnalysisTabIndex };
};

export default useProjectAnalysisTabs;